/* Modern Mattress first-party interaction events.
 * Sends only page/action metadata to GTM's dataLayer; never customer-entered text.
 */
(function () {
  'use strict';
  if (window.__mmTrackingReady) return;
  window.__mmTrackingReady = true;
  window.dataLayer = window.dataLayer || [];

  function push(eventName, details) {
    var payload = { event: eventName, mm_path: window.location.pathname };
    Object.keys(details || {}).forEach(function (key) {
      if (details[key] !== undefined && details[key] !== null && details[key] !== '') payload[key] = details[key];
    });
    window.dataLayer.push(payload);
  }

  function labelFor(element) {
    return (element.getAttribute('data-mm-label') || element.getAttribute('aria-label') || element.textContent || '')
      .replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  document.addEventListener('click', function (event) {
    var element = event.target.closest('a,button,[data-mm-track]');
    if (!element) return;
    var href = element.getAttribute('href') || '';
    var action = element.getAttribute('data-mm-track') || '';
    if (!action) {
      if (href.indexOf('tel:') === 0) action = 'phone_click';
      else if (href.indexOf('sms:') === 0) action = 'text_click';
      else if (/google\.[^/]+\/maps|maps\.apple\.com/.test(href)) action = 'directions_click';
      else if (href.indexOf('/pages/sleep-quiz') > -1) action = 'sleep_quiz_click';
      else if (href.indexOf('/pages/locations') > -1) action = 'store_locator_click';
      else if (href.indexOf('/checkout') > -1) action = 'checkout_click';
      else if (href.indexOf('/cart') > -1) action = 'cart_click';
    }
    if (action) push('mm_interaction', {
      mm_action: action,
      mm_label: labelFor(element),
      mm_destination: href ? href.split('?')[0].slice(0, 160) : ''
    });
  });

  document.addEventListener('submit', function (event) {
    var action = event.target && event.target.getAttribute ? event.target.getAttribute('action') || '' : '';
    if (action.indexOf('/search') > -1) push('mm_site_search', { mm_action: 'search_submit' });
  });

  window.addEventListener('mm:track', function (event) {
    push('mm_interaction', event.detail || {});
  });
})();
